import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudReport = () => import('./staff/crudReport')
const ViewStaffDetailReport = () => import('./staff/detailReport')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'ReportsAuditStaffDashboard',
  crudReport: 'ReportsAuditStaffCrudReport',
  detailReport: 'ReportsAuditStaffDetailReport',
}

const router =
    [
        {
            path: '/st/reports-audit',
            component: DefaultContainer,
            children: [
                {
                    path: '',
                    name: VIEWS.dashboard,
                    component: ViewStaffDashboard,
                    beforeEnter: Permisos.IS_PERSONAL,
                    meta: {
                      title: 'Reporte de auditoria',
                    }                    
                },        
                {
                    path: 'crud',
                    name: VIEWS.crudReport,
                    component: ViewStaffCrudReport,
                    beforeEnter: Permisos.IS_PERSONAL,
                    meta: {
                      title: 'Gestión reporte de auditoría',
                    }                    
                },  
                {
                    path: 'crud/customers/:customersID',
                    name: 'ReportsAuditStaffCrudReportByCustomers',
                    component: ViewStaffCrudReport,
                    beforeEnter: Permisos.IS_PERSONAL,
                    meta: {
                      title: 'Gestión de reporte de auditoría desde cliente',
                    }                    
                },     
                {
                    path: 'detail/:reportID/view',
                    name: VIEWS.detailReport,
                    component: ViewStaffDetailReport,
                    beforeEnter: Permisos.IS_PERSONAL,
                    meta: {
                      title: 'Detalle de reporte de auditoria',
                    }                    
                },
            ]
        },

        {
            path: '/cu/reports-audit',
            component: DefaultContainer,
            children: [

            ]
        },

        {
            path: '/su/reports-audit',
            component: DefaultContainer,
            children: [

            ]
        },
    ]

export default router
export { VIEWS }
